import Request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 获取收藏列表
   */
  static getCollectList() {
    return Request({
      url: `user/collection/collection/list`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  /**
   * 收藏
   */
  static collect(url, data) {
    return Request({
      url,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/MyCollect/MyCollectServ.js